import AccountLabel from './AccountLabel';

export default AccountLabel;
